import { createContext, useContext, useState, ReactNode, useCallback } from "react";

export interface SelectedDMA {
  dma_id: string;
  dma_code: string;
  dma_name: string | null;
  dmz_code: string | null;
  area_code: string | null;
  city: string | null;
}

interface DMAFilterContextType {
  selectedDMA: SelectedDMA | null;
  setSelectedDMA: (dma: SelectedDMA | null) => void;
  clearDMA: () => void;
}

const DMAFilterContext = createContext<DMAFilterContextType>({
  selectedDMA: null,
  setSelectedDMA: () => {},
  clearDMA: () => {},
});

export function DMAFilterProvider({ children }: { children: ReactNode }) {
  const [selectedDMA, setSelectedDMA] = useState<SelectedDMA | null>(null);
  const clearDMA = useCallback(() => setSelectedDMA(null), []);

  return (
    <DMAFilterContext.Provider value={{ selectedDMA, setSelectedDMA, clearDMA }}>
      {children}
    </DMAFilterContext.Provider>
  );
}

export function useDMAFilter() {
  return useContext(DMAFilterContext);
}
